<template>
  <div class="elite-tabs-wrapper-content">
    <h3 class="mb-4">
      {{ `${resellerProduct.name}` }} - {{ $t("COMMON.LOGS") }}
    </h3>
    <log-list-table :filterSubject="resellerProduct" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "reseller-product-view-logs",

  components: { LogListTable },

  props: ["resellerProduct"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
